/**
 * Returns whether a dashboard hostname is a browser loopback/localhost origin.
 * `URL.hostname` retains brackets around IPv6 addresses, so `::1` is represented
 * as `[::1]` when this is called with `window.location.hostname`.
 */
export function isLocalDashboardHost(hostname: string): boolean {
  return hostname === 'localhost' || hostname.endsWith('.localhost') || hostname === '127.0.0.1' || hostname === '[::1]'
}
